import React from "react";
import Head from "next/head";
import type { GetStaticProps } from "next";
import LandingContent from "shared/components-pages/franquicias-landing/LandingContent";
const title =
  "Dirige tu propia oficina REMAX · Franquicias REMAX República Dominicana";
const description =
  "Una franquicia REMAX es un negocio propio, no una vacante de agente. Diriges tu oficina, formas tu equipo y construyes un activo que te pertenece. Solicita tu reunión de presentación.";
export default function FranchiseLanding({ siteUrl, live }: { siteUrl: string; live: boolean }) {
  const url = siteUrl + "/franquicias";
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
          key="viewport"
        />
        <meta name="robots" content="index,follow" key="robots" />
        <link rel="canonical" href={url} key="canonical" />
        <link
          rel="icon"
          href="/franquicias/favicon.svg"
          type="image/svg+xml"
          key="favicon"
        />
        <link
          rel="preload"
          href="/franquicias/fonts/montserrat.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/franquicias/fonts/playfair-italic.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_DO" />
        <meta property="og:site_name" content="REMAX República Dominicana" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <meta
          property="og:image"
          content={siteUrl + "/franquicias/img/hero-bg.webp"}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: title,
              description,
              url,
              inLanguage: "es-DO",
              about: {
                "@type": "Organization",
                name: "REMAX República Dominicana",
                url: siteUrl,
              },
            }).replace(/</g, "\\u003c"),
          }}
        />
      </Head>
      <noscript>
        <style>{`.franchise-landing [data-rv],.franchise-landing [data-rv-clip],.franchise-landing .ph {opacity:1!important;transform:none!important;clip-path:none!important}`}</style>
        <p style={{ padding: 20 }}>
          Activa JavaScript para utilizar el formulario y el calendario.
        </p>
      </noscript>
      <LandingContent live={live} />
    </>
  );
}
FranchiseLanding.standalone = true;
export const getStaticProps: GetStaticProps = async () => {
  const siteUrl = "https://unete.remaxrd.com";
  return { props: { siteUrl, live: process.env.FRANCHISE_HUBSPOT_ENABLED === "true" } };
};
